<div
  class="container"
  appDndCustom
  (fileDropped)="onFileDropped($event)"
  [ngClass]="{ 'disabled': isDisable, 'container': true }">
  <input
    type="file"
    #fileDropRef
    id="fileDropRef"
    (change)="fileBrowseHandler($event.target.files)"
    [disabled]="isDisable"
    [accept]="acceptFile" />
  <img src="assets/icons/import.svg" alt="import" />

  <h3>Drag and drop file here</h3>
  <h3>or</h3>
  <label for="fileDropRef">Browse for file</label>
</div>
<div class="files-list">
  <div class="single-file" *ngFor="let file of files; let i = index">
    <div class="file-icon" style="width: 50px">
      <img src="assets/icons/report.svg" alt="report" />
    </div>
    <div class="info">
      <h4 class="name">
        {{ file?.name }}
        <span *ngIf="file?.progress !== 100"> ({{ file?.progress }} %)</span>
      </h4>
      <p class="size">
        {{ formatBytes(file?.size, 2) }}
      </p>
      <span *ngIf="file?.progress !== 100"
        ><custom-progress [progress]="file?.progress"></custom-progress
      ></span>
      <span *ngIf="file?.progress === 100"> </span>
    </div>

    <div class="delete" (click)="deleteFile(i)">
      <img src="assets/icons/delete.svg" alt="delete" />
    </div>
  </div>
</div>
<p *ngIf="isInvalidFileFormat" class="required-text text-center">
  Please upload vaild file*
</p>
